<template>
  <v-container fluid id="crm">
    <v-layout wrap>
      <v-flex xs12 sm4>
        <h3 class="title">{{ $t('Customer') }}</h3>
      </v-flex>
      <v-flex xs12 sm8 class="text-xs-right">
        <template v-if="loading">
          <v-btn outline loading color="grey"></v-btn>
          <v-btn outline loading color="grey"></v-btn>
        </template>
        <template v-else>
          <template v-if="$store.getters.getPackage != 'premium' || isCoachlab">
            <v-btn color="grey" outline>
              <i class="fas fa-file-import"></i>
              &nbsp;
              {{ $t('Import') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
            <v-btn color="grey" outline>
              <i class="fas fa-file-export"></i>
              &nbsp;
              {{ $t('export') }}&nbsp;
              <v-premium-lock :inline="true"></v-premium-lock>
            </v-btn>
          </template>
          <template v-else>
            <v-btn color="grey" :disabled="delayImport" outline @click="importCustomer">
              <i class="fas fa-file-import"></i>
              &nbsp;
              {{ $t('Import') }}
            </v-btn>
            <v-btn color="grey" outline @click="onExportCustomer()">
              <i class="fas fa-file-export" />
              &nbsp;
              {{ $t('export') }}
            </v-btn>
          </template>
        </template>

        <v-btn dark depressed color="primary" @click="showAdvance = !showAdvance">
          <v-icon>search</v-icon>
          &nbsp;
          {{ $t('advanced search') }}&nbsp;
          <i class="fas fa-angle-down" v-if="!showAdvance"></i>
          <i class="fas fa-angle-up" v-else></i>
        </v-btn>
      </v-flex>
    </v-layout>
    <div
      v-if="showAdvance"
      class="mb-4"
      style="border: 1px solid #eee; border-radius: 10px; position: relative"
    >
      <template>
        <v-premium-plan-popup
          :showAll="false"
          marginTop="65"
          v-if="$store.getters.getPackage != 'premium' || isCoachlab"
          style="border-radius: 10px"
        ></v-premium-plan-popup>
        <filter-customer :total_user="total_user" v-model="filter">
          <v-btn outline color="grey" @click="clearSearch">{{ $t('Clear Search') }}</v-btn>
          <v-btn depressed @click="onSearch" color="primary">
            <i class="fas fa-search mr-1"></i>
            {{ $t('Search') }}
          </v-btn>

          <div slot="append" slot-scope="{ filter }" v-if="selectedBot.theme == 'hafele'">
            <v-divider class="mt-2"></v-divider>
            <v-layout wrap>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp ID') }}</label>
                <input
                  type="text"
                  :placeholder="$t('Emp ID')"
                  v-model="filter.emp_id"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp Name') }}</label>
                <input
                  type="text"
                  :placeholder="$t('Emp First Name')"
                  v-model="filter.emp_first_name"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
              <v-flex xs12 sm4 class="form-control pa-1">
                <label for class="caption">{{ $t('Emp Name') }}</label>
                <input
                  type="text"
                  :placeholder="$t('Emp Last Name')"
                  v-model="filter.emp_last_name"
                  class="form-control"
                  maxlength="255"
                />
              </v-flex>
            </v-layout>
          </div>
        </filter-customer>
      </template>
    </div>
    <v-pagination
      :total-visible="15"
      v-model="pageNumber"
      @input="changePage"
      :length="pagelength"
    ></v-pagination>
    <v-layout row wrap>
      <v-flex xs6></v-flex>
      <v-flex xs6>
        <div class="ma-2 text-xs-right">
          <span class="caption mr-2">{{ $t('Total') }}</span>

          <span :style="`font-size: 19px;color:${$vuetify.theme.primary};font-weight: 600`">{{
            total_user | numberFormat
          }}</span>
        </div>
      </v-flex>
    </v-layout>

    <v-data-table
      :loading="loading"
      :headers="filteredHeader"
      :items="users"
      class="elevation-1"
      v-bind:pagination.sync="pagination"
      hide-actions
    >
      <template v-slot:items="props">
        <customer-item v-model="props.item"></customer-item>
      </template>

      <div class="text-xs-center" slot="no-data">{{ $t('No customer') }}</div>
    </v-data-table>

    <div class="mt-4">
      <v-pagination
        :total-visible="15"
        v-model="pageNumber"
        @input="changePage"
        :length="pagelength"
      ></v-pagination>
    </div>

    <v-dialog v-model="showExport" persistent max-width="800" scrollable>
      <v-card>
        <div class="text-xs-right">
          <v-btn fab flat small @click="showExport = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-divider></v-divider>
        <v-card-text style="max-height: 600px">
          <v-layout wrap>
            <template v-for="page in exportpagecount">
              <v-flex xs6 sm4 md3 :key="`expor_${page}`" class="pa-2">
                <div class="z-border-red text-xs-center py-3">
                  <v-icon x-large>folder_shared</v-icon>
                  <div class="caption">
                    {{ ((page - 1) * exportlimit + 1) | numberFormat }} -
                    <template v-if="page == exportpagecount">
                      {{ total_user | numberFormat }}
                    </template>
                    <template v-else>{{ (page * exportlimit) | numberFormat }}</template>
                  </div>
                  <v-btn
                    small
                    color="primary"
                    depressed
                    @click="exportCustomer((page - 1) * exportlimit)"
                    >download</v-btn
                  >
                </div>
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Customers from './Customers.js'
export default {
  mixins: [Customers],
}
</script>



// WEBPACK FOOTER //
// src/components/view/dashboard/Customers.vue